import { useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api'
import type { PaginationQuery } from '@/types/api'

export function useProjects(query: PaginationQuery & { status?: string } = {}) {
  return useQuery({
    queryKey: ['projects', query],
    queryFn: () => api.projects.list(query),
    select: (res) => res.data,
  })
}
